const hamburger = document.querySelector('.hamburger');
const navMenu = document.querySelector('.nav-menu');

if (hamburger !== null && navMenu !== null) {
  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('active');
    navMenu.classList.toggle('active');
  });

  navMenu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      hamburger.classList.remove('active');
      navMenu.classList.remove('active');
    });
  });
}

function scrollToSection(sectionId) {
  const section = document.querySelector(`.${sectionId}`);
  if (section) {
    const offset = section.getBoundingClientRect().top + window.scrollY - 60;
    scrollTo({ top: offset, behavior: 'smooth' });
  }
}

const hash = location.hash.slice(1);
if (hash !== '') {
  scrollToSection(hash);
}

window.addEventListener('hashchange', () => {
  const hash = location.hash.slice(1);
  if (hash !== '') {
    scrollToSection(hash);
  }
});

const heroImages = document.querySelectorAll('.hero img');

if (heroImages.length > 1) {
  for (const img of heroImages) {
    if (img.dataset.bg) {
      img.style.backgroundColor = img.dataset.bg;
    }
  }

  let currentIndex = 0;
  let nextIndex = 1;
  let timer;

  const startTimer = () => {
    timer = setInterval(() => {
      heroImages[currentIndex].classList.remove('current');

      currentIndex = nextIndex;
      nextIndex = (nextIndex + 1) % heroImages.length;

      heroImages[currentIndex].classList.remove('next');
      heroImages[currentIndex].classList.add('current');

      heroImages[nextIndex].classList.add('next');
    }, 5000);
  };

  startTimer();

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      startTimer();
    } else {
      clearInterval(timer);
      timer = undefined;
    }
  });
}
